<template>
  <v-main>
    <v-container>
      <div class="desktop">
        <v-row justify="center">
          <v-col md="3" v-for="item in tiles" :key="item.title">
            <v-card
              @click="route(item.action)"
              class="pa-2 pb-0 rounded"
              :class="item.enabled"
              outlined
              tile
              rounded
              color="blue lighten-3"
              elevation="5"
            >
              {{item.title}}
              <div style="position: absolute; bottom:0px; right:0px">
                <v-icon color="blue lighten-4" size="150">{{item.icon}}</v-icon>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      tiles: [
        {
          title: this.$t("tiles.listSupplier"),
          action: "edit",
          icon: "mdi-format-list-bulleted",
          enabled: "box",
        },
        {
          title: this.$t("tiles.addSupplier"),
          action: "add",
          icon: "mdi-playlist-plus",
          enabled: "box",
        },
        {
          title: this.$t("tiles.editSupplier"),
          action: "edit",
          icon: "mdi-playlist-edit",
          enabled: "box",
        },
        {
          title: this.$t("tiles.orderSupplier"),
          action: "edit",
          //icon: "mdi-cart-outline",
          icon: "add_shopping_cart",
          enabled: "box",
        },
        {
          title: this.$t("tiles.offerSupplier"),
          action: "edit",
          icon: "mdi-offer",
          enabled: "box",
        },
        {
          title: this.$t("tiles.reviewSupplier"),
          action: "edit",
          icon: "bug_report",
          enabled: "box",
        },
        {
          title: this.$t("tiles.findSupplier"),
          action: "edit",
          icon: "mdi-magnify",
          enabled: "box",
        },
        {
          title: this.$t("tiles.emailSupplier"),
          action: "edit",
          icon: "mdi-email-search",
          enabled: "box",
        }
      ],
    };
  },
};
</script>

<style scoped>
main {
  padding: 0px !important;
  background-image: url("../assets/img/landing-bcg.jpg");
  background-position: top top;
  background-repeat: repeat-y;
  background-attachment: fixed;
  background-size: cover;
  background-color: white;
}
</style>